// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__185Ci","emails":"CreateEditClinics_emails__1IyOb","emailTagLabel":"CreateEditClinics_emailTagLabel__14Ped"};